import { render, staticRenderFns } from "./CrawlerInstanceSizeChart.vue?vue&type=template&id=31064f0e&"
import script from "./CrawlerInstanceSizeChart.vue?vue&type=script&lang=js&"
export * from "./CrawlerInstanceSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports